import ErrorsRouteConfig from './errors.route';
import angular from 'angular';

import ErrorComponent from './general/error.component';

const ErrorsModule = angular
  .module('app.errors', ['ui.router', 'gettext'])
  .config(ErrorsRouteConfig)
  .component('error', ErrorComponent);

export default ErrorsModule.name;
